import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { Notches } from '@phosphor-icons/react/dist/ssr';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

export interface TextInputProps extends ComponentPropsWithoutRef<'textarea'> {
  error?: boolean;
  resize?: 'none' | 'vertical' | 'both';
  sectionClassName?: string;
  testId?: string;
}

const baseClasses = clsx(`
  anim-effect
  focus:focus-outline
  text-body
  min-h-[96px]
  w-full
  rounded-s
  bg-main
  p-xs
  ring-1
  ring-inset
  ring-main
  hover:outline
  hover:outline-3
  hover:outline-hover
  hover:ring-strong 
`);

const resizeClasses = {
  none: clsx('resize-none'),
  both: clsx('resize'),
  vertical: clsx('resize-y'),
};

const errorClasses = clsx('ring-2 ring-error');

const TextArea = forwardRef<HTMLTextAreaElement, TextInputProps>(
  (
    { error, resize = 'none', className, testId, sectionClassName, ...props },
    ref,
  ) => (
    <div className={clsx('relative', sectionClassName)}>
      <textarea
        className={clsx(
          className,
          baseClasses,
          resizeClasses[resize],
          error && errorClasses,
        )}
        {...props}
        data-testid={testId}
        ref={ref}
      />
      {resize !== 'none' && (
        <PhosphorIcon
          Icon={Notches}
          variant="regular"
          className="custom-resizer icon-s pointer-events-none absolute right-xxs bottom-xs"
        />
      )}
    </div>
  ),
);

TextArea.displayName = 'TextArea';

export default TextArea;
